import { Component } from "react";
import "../../../../styles/css/dashboard.scss";
import "../../../../App.css";
import { connect } from "react-redux";
import apis from "../../../../Providers.Api/apis";
import { enableRipple } from "@syncfusion/ej2-base";
import "../../../../styles/css/form.scss";
import Inputbox from "../../../../Components/Inputs/TextInput/Inputbox";
import SelectBox from "../../../../Components/Inputs/SelectBox/SelectBox";
import ConfirmModal from "../../../../Components/Dialogs/ConfirmDialog/ConfirmModal";
import Submenu from "../../../../Components/Layout/Tabs2/SubMenu";
import { Link } from "react-router-dom";
import LoadingOverlay from "../../../../Components/Navigation/LoadingOverlay/LoadingOverlay"
import { convertApiResponseObjectToLower, convertObjectVariableFirstLatterToUpperCase } from "../../../../Common/Helper"
import { appContext } from "../../../../AppContext";

enableRipple(true);

class EditTaskType extends Component {
  private labels = appContext().labels;
  private local = appContext().localStorageProvider;

  state = {
    isLoadingToSave: false,
    filter: "",
    phoneNumber: null,
    loading: false,
    activePage: 0,
    updates: false,
    identityProviderId: null,
    id: null,
    displayName: null,
    userPreferences: null,
    task_Type_Id: 0,
    task_Type_Name: "",
    task_Type_IsEnabled: 0,
    parentID: "",
    task_Category_Id: 0,
    task_Type_Priority: 0,
    task_Type_Resolve_Duration: 0,
    task_IsDefault_Space_Clean_Task: 0,
    task_Type_Priority_Resolve_Duration: 0,
    equip_Type: "",
    node_Id: 0,
    space_Type: "",
    taskCategoryName: "",
    task_Type_Add_Details: 0,
    organisationState: "",
    organisationPath: "",
    organisationId: null,
    showOrganisation: false,
    regionState: "",
    regionPath: "",
    regionId: null,
    showRegion: false,
    buildingState: "",
    buildingPath: "",
    buildingId: null,
    showBuilding: false,
    floorState: "",
    floorPath: "",
    floorId: null,
    showFloor: false,
    zoneState: "",
    zonePath: "",
    zoneId: null,
    showZone: false,
    roomState: "",
    roomPath: "",
    roomId: null,
    showRoom: false,
    deskState: "",
    deskPath: "",
    deskId: null,
    showDesk: false,
    spaceFilter: "",
    show: false,
    isDelete: false,
    isUpdateRight: false,
    isDeleteRight: false,
    apiVersion: 11
  };

  componentDidMount() {
    const { match, history }: any = this.props;
    if (history.location.state === 'cancel') {
      this.setState({ activePage: 2 });
    }
    let versions = 11;
    const version = this.local.getVersion();
    if (version !== 0) {
      versions = version;
    }
    this.setState({
      filter: "TaskTypes",
      spaceFilter: sessionStorage.getItem('spaceFilter'),
      apiVersion: versions
    })

    if (match.params.id === "0" && match.params.nodeid) {

      this.setState({
        node_Id: parseInt(match.params.nodeid),
        displayName: "New Task Type",
        isUpdateRight: true,
      })
    } else {
      this.getRightList();
      this.setState({
        node_Id: parseInt(match.params.nodeid),
        id: match.params.id,
      }, () => {
        this.getDetails(this.state.id, "TaskTypes");
      })
      // match.params.id && this.getDetails(match.params.id, this.state.filter);
    }

  }

  getRightList = () => {

    const res = this.local.getIbssRightList();

    if (res.ADMINPORTAL && res.ADMINPORTAL.TaskTypes && res.ADMINPORTAL.TaskTypes.indexOf("Update") > -1) {
      this.setState({
        isUpdateRight: true
      })
    }
    if (res.ADMINPORTAL && res.ADMINPORTAL.TaskTypes && res.ADMINPORTAL.TaskTypes.indexOf("Delete") > -1) {
      this.setState({
        isDeleteRight: true
      })
    }
  }

  getDetails = (id: any, filter: any) => {

    this.setState({ loading: true });
    const node_Id = this.state.node_Id;

    if (sessionStorage.getItem('showOrganisation') === "true") {
      this.setState({
        showOrganisation: true,
        organisationState: sessionStorage.getItem('organisationState'),
        orgnisationnPath: sessionStorage.getItem('orgnisationnPath'),
        organisationId: sessionStorage.getItem('organisationId')
      })
    }

    if (sessionStorage.getItem('showRegion') === "true") {
      this.setState({
        showRegion: true,
        regionState: sessionStorage.getItem('regionState'),
        regionPath: sessionStorage.getItem('regionPath'),
        regionId: sessionStorage.getItem('regionId')
      })
    }

    if (sessionStorage.getItem('showBuilding') === "true") {
      this.setState({
        showBuilding: true,
        buildingState: sessionStorage.getItem('buildingState'),
        buildingPath: sessionStorage.getItem('buildingPath'),
        buildingId: sessionStorage.getItem('buildingId')
      })
    }
    if (sessionStorage.getItem('showFloor') === "true") {
      this.setState({
        showFloor: true,
        floorState: sessionStorage.getItem('floorState'),
        floorPath: sessionStorage.getItem('floorPath'),
        floorId: sessionStorage.getItem('floorId')
      })
    }
    if (sessionStorage.getItem('showZone') === "true") {
      this.setState({
        showZone: true,
        zoneState: sessionStorage.getItem('zoneState'),
        zonePath: sessionStorage.getItem('zonePath'),
        zoneId: sessionStorage.getItem('zoneId')
      })
    }
    if (sessionStorage.getItem('showRoom') === "true") {
      this.setState({
        showRoom: true,
        roomState: sessionStorage.getItem('roomState'),
        roomPath: sessionStorage.getItem('roomPath'),
        roomId: sessionStorage.getItem('roomId')
      })
    }
    if (sessionStorage.getItem('showDesk') === "true") {
      this.setState({
        showDesk: true,
        deskState: sessionStorage.getItem('deskState'),
        deskPath: sessionStorage.getItem('deskPath'),
        deskId: sessionStorage.getItem('deskId')
      })
    }

    apis.getTaskTypesById(node_Id, id, filter).then((res) => {
      const lowerCaseData = convertApiResponseObjectToLower(res.data)
      this.setState({ ...lowerCaseData });
      this.setState({
        loading: false,
        displayName: lowerCaseData.task_Type_Name
      });
    }).catch((error: any) => { });
  };
  submit = () => {
    this.setState({ isLoadingToSave: true });
    const { match, history }: any = this.props;
    const { equip_Type, node_Id, task_Type_Add_Details, space_Type, task_Type_IsEnabled, task_IsDefault_Space_Clean_Task, task_Type_Id, id, task_Category_Id, task_Type_Name, task_Type_Priority, task_Type_Resolve_Duration, task_Type_Priority_Resolve_Duration, userPreferences, updates }: any = this.state;

    let payload = {
      "task_Category_Id": parseInt(task_Category_Id),
      "task_Type_Name": task_Type_Name,
      "task_Type_Priority": parseInt(task_Type_Priority),
      "task_Type_Resolve_Duration": parseInt(task_Type_Resolve_Duration),
      "task_Type_Priority_Resolve_Duration": parseInt(task_Type_Priority_Resolve_Duration),
      "task_Type_Id": parseInt(task_Type_Id),
      "task_IsDefault_Space_Clean_Task": task_IsDefault_Space_Clean_Task,
      "task_Type_IsEnabled": task_Type_IsEnabled,
      "space_Type": space_Type,
      "task_Type_Add_Details": task_Type_Add_Details,
      "equip_Type": equip_Type
    }

    if (this.state.apiVersion > 10) {
      // use upperCase
      payload = convertObjectVariableFirstLatterToUpperCase(payload)
    } else if (this.state.apiVersion === 10) {
      // use lowerCase
    }

    if (match.params.id === "0") {
      this.create(node_Id, payload);
    } else {
      this.update(node_Id, id, payload);
    }
  };

  create = (nodeId: any, payload: any) => {
    const { history }: any = this.props;
    apis.createTaskTypes(payload, nodeId).then((res) => {
      const { history }: any = this.props;
      this.setState({
        updates: true,
        isLoadingToSave: false,
      }, () => {
        history.push("/portfolio-setup-spaces/filter=Building/TaskTypes/nodeid=" + res.data.node_Id + "/id=" + res.data.id);
        window.location.reload();
      })
    }).catch((error: any) => {
      this.setState({ isLoadingToSave: false });
    });
  }

  update = (nodeId: any, id: any, payload: any) => {
    const { match, history }: any = this.props;
    const { updates, filter }: any = this.state;
    if (updates) {
      apis.updateTaskTypes(nodeId, id, payload).then((res) => {
        this.setState({ isLoadingToSave: false });
        history.push("/portfolio-setup-spaces/edit/" + nodeId + "/Building/7");
      }).catch((error: any) => {
        this.setState({ isLoadingToSave: false });
      });
    } else {
      this.setState({ isLoadingToSave: false });
      history.push("/portfolio-setup-spaces/edit/" + nodeId + "/Building/7");
    }
  };

  change = (e: any) => {
    this.setState({ updates: true })
    this.setState({ [e.target.name]: e.target.value });
  };
  isDelete = () => {
    this.setState({
      isDelete: !this.state.isDelete,
      show: !this.state.show,
    })
    this.delete();
  }

  cancelDeleteModal = () => {
    this.setState({
      isDelete: !this.state.isDelete,
      show: !this.state.show,
    })
  }
  delete = () => {
    const { node_Id }: any = this.state;
    const { match }: any = this.props;
    const id = match.params.id;
    if (this.state.isDelete) {
      apis.deleteTaskTypesById(node_Id, id).then((res) => {
        const { history }: any = this.props;
        history.push("/portfolio-setup-spaces/edit/" + node_Id + "/Building/7");
      }).catch((error: any) => { });
    }
  };
  handleModal = () => {
    this.setState({
      show: !this.state.show,
    })
  }

  cancel = () => {
    const { updates, node_Id, buildingId } = this.state
    const { history }: any = this.props;
    if (updates) {
      this.handleModal();
    } else {
      history.push("/portfolio-setup-spaces/edit/" + node_Id + "/Building/7");
    }
  }


  emptyLocalstorage = (filter: any) => {
    if (filter === "Root") {
      sessionStorage.setItem('showOrganisation', "");
      sessionStorage.setItem('organisationState', "");
      sessionStorage.setItem('orgnisationnPath', '');
      sessionStorage.setItem('organisationId', "");
    }
    if (filter === "Root" || filter === "Region") {
      sessionStorage.setItem('showRegion', "");
      sessionStorage.setItem('regionState', "");
      sessionStorage.setItem('regionPath', '');
      sessionStorage.setItem('regionId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building") {
      sessionStorage.setItem('showBuilding', "");
      sessionStorage.setItem('buildingState', "");
      sessionStorage.setItem('buildingPath', '');
      sessionStorage.setItem('buildingId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor") {
      sessionStorage.setItem('showFloor', "");
      sessionStorage.setItem('floorState', "");
      sessionStorage.setItem('floorPath', '');
      sessionStorage.setItem('floorId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone") {
      sessionStorage.setItem('showZone', "");
      sessionStorage.setItem('zoneState', "");
      sessionStorage.setItem('zonePath', '');
      sessionStorage.setItem('floorId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone" || filter === "Spaces") {
      sessionStorage.setItem('showRoom', "");
      sessionStorage.setItem('roomState', "");
      sessionStorage.setItem('roomPath', '');
      sessionStorage.setItem('roomId', "");
    }
    if (filter === "Root" || filter === "Region" || filter === "Building" || filter === "Floor" || filter === "Zone" || filter === "Spaces" || filter === "Desk") {
      sessionStorage.setItem('showDesk', "");
      sessionStorage.setItem('deskState', "");
      sessionStorage.setItem('deskPath', '');
      sessionStorage.setItem('deskId', "");
    }
  }


  linkPath = (data: any) => {
    const { filter } = this.state
    const { history }: any = this.props;

    if (data === "Root") {
      this.setState({
        showOrganisation: false,
        showRegion: false,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Root");
        history.push("/portfolio-setup-spaces/edit/" + this.state.organisationId + "/Root");
        // this.getDetails(this.state.organisationId, 'Root');
      })
    }

    if (data === "Region") {
      this.setState({
        showOrganisation: true,
        showRegion: false,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Region");
        history.push("/portfolio-setup-spaces/edit/" + this.state.regionId + "/Region");
        // this.getDetails(this.state.regionId, 'Region');
      })

    }

    if (data === "Building") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: false,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Building");
        history.push(this.state.buildingPath);
        // this.getDetails(this.state.buildingId, 'Building');
      })

    }

    if (data === "Floor") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: false,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Floor");
        history.push(this.state.floorPath);
        // this.getDetails(this.state.floorId, 'Floor');
      })

    }

    if (data === "Zone") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: false,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Zone");
        history.push(this.state.zonePath);
        // this.getDetails(this.state.zoneId, 'Zone');
      })
    }

    if (data === "Spaces") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: true,
        showRoom: false,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Spaces");
        history.push(this.state.roomPath);
        // this.getDetails(this.state.roomId, 'Spaces');
      })
    }

    if (data === "Desk") {
      this.setState({
        showOrganisation: true,
        showRegion: true,
        showBuilding: true,
        showFloor: true,
        showZone: true,
        showRoom: true,
        showDesk: false,
        reload: false
      }, () => {
        this.emptyLocalstorage("Desk");
        history.push(this.state.deskPath);
        // this.getDetails(this.state.deskId, 'Desk');
      })
    }

  }

  setChecked = (e: any) => {
    this.setState({ updates: true })
    if (e.target.name === 'task_Type_IsEnabled') {
      if (this.state.task_Type_IsEnabled == 0) {
        this.setState({
          task_Type_IsEnabled: 1
        })
      } else {
        this.setState({
          task_Type_IsEnabled: 0
        })
      }

    }

    if (e.target.name === 'task_IsDefault_Space_Clean_Task') {
      if (this.state.task_IsDefault_Space_Clean_Task == 0) {
        this.setState({
          task_IsDefault_Space_Clean_Task: 1
        })
      } else {
        this.setState({
          task_IsDefault_Space_Clean_Task: 0
        })
      }

    }

    if (e.target.name === 'task_Type_Add_Details') {
      if (this.state.task_Type_Add_Details == 0) {
        this.setState({
          task_Type_Add_Details: 1
        })
      } else {
        this.setState({
          task_Type_Add_Details: 0
        })
      }

    }

  };

  render() {
    const { task_Type_Name, task_Type_Id, task_Category_Id, space_Type, task_Type_Resolve_Duration, task_Type_Priority,
      task_Type_Priority_Resolve_Duration, task_Type_IsEnabled, task_IsDefault_Space_Clean_Task, task_Type_Add_Details, equip_Type }: any = this.state;
    const { history }: any = this.props;

    const confModalData = this.state.isDelete ? {
      name: this.state.task_Type_Name,
      show: this.state.show,
      handleModal: this.cancelDeleteModal,
      okButton: this.delete,
      modalHeading: this.labels.HubLabelConfirmation,
      modalMessage: this.labels.HubLabelDeleteMessage,
    }
      : {
        name: this.state.task_Type_Name,
        show: this.state.show,
        handleModal: this.handleModal,
        okButton: () => { history.push("/portfolio-setup-spaces/edit/" + this.state.buildingId + "/Building/7") },
        modalHeading: this.labels.HubLabelConfirmation,
        modalMessage: this.labels.HubLabelConfirmCancelMessage,
      }

    const task_Type_NameFld = {
      name: "task_Type_Name",
      label: this.labels.HubLabelTaskTypeName,
      value: task_Type_Name,
      mandatory: true,
      placeholder: this.labels.HubLabelProvideTaskTypeName,
      onchange: this.change,
    }

    const task_Type_IdFld = {
      name: "task_Type_Id",
      label: this.labels.HubLabelTaskTypeId,
      value: task_Type_Id,
      mandatory: true,
      placeholder: this.labels.HubLabelProvideTaskTypeIdLabel,
      onchange: this.change,
    }

    const task_Category_IdFld = {
      name: "task_Category_Id",
      label: this.labels.HubLabelCategoryId,
      value: task_Category_Id,
      mandatory: true,
      placeholder: this.labels.HubLabelProvideCategoryId,
      onchange: this.change,
    }

    const space_TypeFld = {
      name: "space_Type",
      label: this.labels.HubLabelSpaceType,
      value: space_Type,
      mandatory: true,
      placeholder: this.labels.HubLabelProvideSpaceTypeLabel,
      onchange: this.change,
    }

    const task_Type_Resolve_DurationFld = {
      name: "task_Type_Resolve_Duration",
      label: this.labels.HubLabelResolveDuration,
      value: task_Type_Resolve_Duration,
      mandatory: true,
      placeholder: this.labels.HubLabelProvideResolveDuration,
      onchange: this.change,
    }

    const task_Type_PriorityFld = {
      name: "task_Type_Priority",
      label: this.labels.HubLabelPriorityLabel,
      value: task_Type_Priority,
      mandatory: true,
      placeholder: this.labels.HubLabelProvidePriority,
      onchange: this.change,
    }

    const task_Type_Priority_Resolve_DurationFld = {
      name: "task_Type_Priority_Resolve_Duration",
      label: this.labels.HubLabelPriorityResolveDuration,
      value: task_Type_Priority_Resolve_Duration,
      mandatory: true,
      placeholder: this.labels.HubLabelProvidePriorityResolveDuration,
      onchange: this.change,
    }

    const equip_TypeFld = {
      name: "equip_Type",
      label: this.labels.HubLabelEquipmentType,
      value: equip_Type,
      onchange: (value: any) => {
        this.setState({
          equip_Type: value,
          updates: true
        });
      },
      type: "option",
      options: [
        { title: this.labels.HubLabelAHU, value: 0 },
        { title: this.labels.HubLabelCoffeeMachine, value: this.labels.HubLabelCoffeeMachine },
        { title: this.labels.HubLabelDisplayScreen, value: this.labels.HubLabelDisplayScreen },
        { title: this.labels.HubLabelHearingAid, value: this.labels.HubLabelHearingAid },
        { title: this.labels.HubLabelPresentationAid, value: this.labels.HubLabelPresentationAid },
        { title: this.labels.HubLabelIndoorUnit, value: this.labels.HubLabelIndoorUnit },
        { title: this.labels.HubLabelOutdoorUnit, value: this.labels.HubLabelOutdoorUnit },
        { title: this.labels.HubLabelFireAlarmPanel, value: this.labels.HubLabelFireAlarmPanel },
        { title: this.labels.HubLabelVisualAndSounder, value: this.labels.HubLabelVisualAndSounder },
        { title: this.labels.HubLabelHeatDetector, value: this.labels.HubLabelHeatDetector },
        { title: this.labels.HubLabelSmokeDetector, value: this.labels.HubLabelSmokeDetector },
        { title: this.labels.HubLabelCallPoint, value: this.labels.HubLabelCallPoint },
        { title: this.labels.HubLabelFireExtinguisher, value: this.labels.HubLabelFireExtinguisher },
        { title: this.labels.HubLabelWaterMeter, value: this.labels.HubLabelWaterMeter },
        { title: this.labels.HubLabelGasMeter, value: this.labels.HubLabelGasMeter },
        { title: this.labels.HubLabelThermalMeter, value: this.labels.HubLabelThermalMeter },
        { title: this.labels.HubLabelElectricMeter, value: this.labels.HubLabelElectricMeter },
        { title: this.labels.HubLabelController, value: this.labels.HubLabelController },
        { title: this.labels.HubLabelups, value: this.labels.HubLabelups },
        { title: this.labels.HubLabelchp, value: this.labels.HubLabelchp },
        { title: this.labels.HubLabelGenerator, value: this.labels.HubLabelGenerator },
        { title: this.labels.HubLabeltrenchHeater, value: this.labels.HubLabeltrenchHeater },
        { title: this.labels.HubLabelAirCurtain, value: this.labels.HubLabelAirCurtain },
        { title: this.labels.HubLabelfcu, value: this.labels.HubLabelfcu },
        { title: this.labels.HubLabelpu, value: this.labels.HubLabelpu },
        { title: this.labels.HubLabelCoolingTower, value: this.labels.HubLabelCoolingTower },
        { title: this.labels.HubLabelChiller, value: this.labels.HubLabelChiller },
        { title: this.labels.HubLabelCalorifier, value: this.labels.HubLabelCalorifier },
        { title: this.labels.HubLabelBoiler, value: this.labels.HubLabelBoiler },
        { title: this.labels.HubLabelHeatPump, value: this.labels.HubLabelHeatPump },
        { title: this.labels.HubLabelThermalStore, value: this.labels.HubLabelThermalStore },
        { title: this.labels.HubLabelphe, value: this.labels.HubLabelphe },
        { title: this.labels.HubLabelPump, value: this.labels.HubLabelPump },
        { title: this.labels.HubLabelPumpSet, value: this.labels.HubLabelPumpSet },
        { title: this.labels.HubLabelTef, value: this.labels.HubLabelTef },
        { title: this.labels.HubLabelEF, value: this.labels.HubLabelEF },
        { title: this.labels.HubLabelSF, value: this.labels.HubLabelSF },
        { title: this.labels.HubLabelVAV, value: this.labels.HubLabelVAV },
        { title: this.labels.HubLabelCAV, value: this.labels.HubLabelCAV }
      ]
    };

    const props = {
      ...this.props,
      submenu: [
        {
          title: this.labels.HubTabProperties,
          tabNo: 0,
          active: this.state.activePage === 0 ? true : false,
        }
      ],
      activePageValue: this.state.activePage,
      childValue: (i: any) => {
        this.setState({ activePage: i });
      },
    };


    return (
      <>
        {this.state.isLoadingToSave && <LoadingOverlay />} 
          <div className="rightPanel">
            <Submenu {...props} />
            <div className="rightPanel-main-content-form">
              {this.state.show ? (
                <ConfirmModal {...confModalData} />
              ) : ""}
              <div className="form-panel">
                <div className="form-panel-heading">
                  <div className="form-panel-breadcrumbs">
                    <div className="breadcrumbs">
                      {this.state.id === 0 ?
                        <Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/edit/` + this.state.node_Id + `/Building` }}>{this.labels.HubTaskStates}</Link>
                        :
                        <div>
                          <Link className="breadcrumbs" to={{ pathname: `/portfolio-setup-spaces/filter=` + this.state.spaceFilter }}>{this.labels.HubLabelSpaces}</Link>
                          {this.state.showOrganisation && this.state.organisationState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.organisationPath }} onClick={() => this.linkPath('Root')}> / {this.state.organisationState}</Link>)}
                          {this.state.showRegion && this.state.regionState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.regionPath }} onClick={() => this.linkPath('Region')}> / {this.state.regionState}</Link>)}
                          {this.state.showBuilding && this.state.buildingState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.buildingPath }} onClick={() => this.linkPath('Building')}> / {this.state.buildingState}</Link>)}
                          {this.state.showFloor && this.state.floorState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.floorPath }} onClick={() => this.linkPath('Floor')}> / {this.state.floorState}</Link>)}
                          {this.state.showZone && this.state.zoneState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.zonePath }} onClick={() => this.linkPath('Zone')}> / {this.state.zoneState}</Link>)}
                          {this.state.showRoom && this.state.roomState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.roomState }} onClick={() => this.linkPath('Spaces')}> / {this.state.roomState}</Link>)}
                          {this.state.showDesk && this.state.deskState != "" && (<Link className="breadcrumbs" to={{ pathname: this.state.deskState }} onClick={() => this.linkPath('Desk')}> / {this.state.deskState}</Link>)}
                        </div>
                      }

                    </div>
                    <div className="page-title mb-20"><h1>{this.state.displayName}</h1></div>
                  </div>
                </div>


                {this.state.activePage === 0 && (
                  <div className="main-content">
                    {this.state.loading && (<div className="row">{this.labels.HubLabelLoadingText}</div>)}
                    <div className="height-control">
                      {this.state.loading || (
                        <div className="card card-scroller">
                          <div className="p-45">
                            <form>

                              <div className="row">
                                <div className="col-6 pr-2"><Inputbox {...task_Type_NameFld} /> </div>
                                <div className="col-6"><Inputbox {...task_Type_IdFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-6 pr-2"><Inputbox {...task_Category_IdFld} /></div>
                                <div className="col-6"><Inputbox {...space_TypeFld} /></div>
                              </div>

                              <div className="row">
                                <div className="col-3 pr-2">
                                  <Inputbox {...task_Type_Resolve_DurationFld} />
                                </div>
                                <div className="col-3">
                                  <Inputbox {...task_Type_PriorityFld} />
                                </div>
                                <div className="col-3 pr-2">
                                  <Inputbox {...task_Type_Priority_Resolve_DurationFld} />
                                </div>
                                <div className="col-3"></div>
                              </div>

                              <div className="row" >
                                <div className="col-6 pr-2  div-flex">
                                  <div className="col-6 pr-2 input-controls">
                                    <label className="check-label">{this.labels.HubLabelEnabled}</label>
                                    <input name="task_Type_IsEnabled" type="checkbox" className="input-check-box-label border"
                                      defaultChecked={task_Type_IsEnabled === 1 ? true : false} onChange={this.setChecked} />
                                  </div>
                                  <div className="col-6 input-controls">
                                    <label className="check-label">{this.labels.HubLabelDefaultCleanTask}</label>
                                    <input name="task_IsDefault_Space_Clean_Task" type="checkbox" className="input-check-box-label border"
                                      defaultChecked={task_IsDefault_Space_Clean_Task === 1 ? true : false} onChange={this.setChecked} />
                                  </div>
                                </div>
                                <div className="col-3 pr-2 input-controls">
                                  <label className="check-label">{this.labels.HubLabelAddDetails}</label>
                                  <input name="task_Type_Add_Details" type="checkbox" className="input-check-box-label border"
                                    defaultChecked={task_Type_Add_Details === 1 ? true : false} onChange={this.setChecked} />
                                </div>
                                <div className="col-3 input-controls">
                                  <SelectBox {...equip_TypeFld} />
                                </div>
                              </div>

                            </form>
                          </div>
                        </div>)}
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="rightPanel-main-button-group">
              <div>
                <button className="button-tertiary mr-2" onClick={() => this.cancel()} >{this.labels.HubButtonCancel}</button>
                {(this.state.id !== null && this.state.isDeleteRight === false) && (
                  <button className="button-tertiary-disable mr-2" disabled={true}>{this.labels.HubButtonDelete}</button>
                )}
                {(this.state.id !== null && this.state.isDeleteRight === true) && (
                  <button className="button-tertiary mr-2" onClick={() => this.delete()} >{this.labels.HubButtonDelete}</button>
                )}
              </div>
              <div className=" space-between">
                {this.state.isUpdateRight === false &&
                  <button className="button-primary-disable ml-2" disabled={true}>{this.labels.HubButtonSave}</button>
                }
                {this.state.isUpdateRight === true &&
                  <button className="button-primary ml-2" onClick={() => this.submit()}>{this.labels.HubButtonSave}</button>
                }
              </div>
            </div>
          </div>
      </>
    );
  }
}
const mapStateToProps = (state: any) => {
  return {
    currentPageTitle: state.currentPageTitle,
    lightModeTheme: state.lightModeTheme,
    identityProvidersStore: state.identityProvidersDetails,
    mainPageTitle: state.mainPageTitle,
  };
};
export default connect(mapStateToProps)(EditTaskType);